import axios from 'axios';

const API_URL = '/api/foundation';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const foundationService = {
  /**
   * Get complete foundation data
   */
  async getCompleteFoundation() {
    try {
      const response = await axios.get(`${API_URL}/complete`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get foundation data'
      };
    }
  }
};

export default foundationService;
